import { render, staticRenderFns } from "./agentWithRealTime.vue?vue&type=template&id=33ea144e&"
import script from "./agentWithRealTime.vue?vue&type=script&lang=js&"
export * from "./agentWithRealTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports